import { Injectable } from '@angular/core';
import { EMPTY_CONFIG } from '@app/core/models/configuration.model';
import { EidosUser } from '@app/eidos/models/user-info.model';
import { IEidosEnvironment } from '@app/eidos/services/environment.interface';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  configuration:BehaviorSubject<IEidosEnvironment> = new BehaviorSubject(EMPTY_CONFIG);
  user:BehaviorSubject<EidosUser> = new BehaviorSubject(new EidosUser());
  sideNavOpen:BehaviorSubject<boolean> = new BehaviorSubject(false);
  sideCalOpen:BehaviorSubject<boolean> = new BehaviorSubject(false);
}
